var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('el-menu',{attrs:{"unique-opened":"","default-active":'menu'+_vm.firstId}},_vm._l((_vm.menuList),function(item){return _c('submenu',{key:item.id,attrs:{"item":item,"msgCountList":_vm.msgCountList}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }